export default "__VITE_ASSET__D_5$9LeD__"